import { Typography, useMediaQuery } from '@mui/material'

interface ReportHeadingProps {
    heading: string
}
const GenerateReportHeading = ({ heading }: ReportHeadingProps) => {
    const matches = useMediaQuery('(min-width:900px)');
    return (
            <Typography variant={matches ? 'h4' : 'h5'} textAlign='center' sx={{mt:5}} >{heading}</Typography>
    )
}
export default GenerateReportHeading